import React, { useCallback } from "react";

export const toJsonShape = (str: string) => {
    const decoded = b64DecodeUnicode(str)
    const sefariaContent = decoded ? JSON.parse(decoded) : null;
    return sefariaContent;
}

export const b64DecodeUnicode = (str: string) => {
    try {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch (err) {
        console.error(err)
    }
}

export const isExternalLinkHasVideoPlatform = (link: string): { platform: string, hasPlatform: boolean } => {
    if (link?.includes('youtube')) return ({
        platform: 'youtube',
        hasPlatform: true
    })
    else if (link?.includes('vimeo')) return ({
        platform: 'vimeo',
        hasPlatform: true
    })
    else return {
        platform: '',
        hasPlatform: false
    }
}


export const stringObjToObj = (s: string) => {
    return JSON.parse(s);
}

export const toFormData = (obj: any) => {
    try {
        const formData = new FormData();
        for (const key in obj) {
            formData.append(key, obj[key]);
        }
        return formData
    } catch (err) {
        throw err
    }

}

export const clean = (obj: any) => {
    for (var propName in obj) {
        if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
}

export const removeDuplicateEvents = (posts: any[]) => {

    const eventsLessPosts = posts.filter(p => p?.eventContentItem === undefined);
    const pinnedToTop = eventsLessPosts.filter(p => p.postSettings[0].pinToTop).sort((a: any, b: any) => b.created - a.created);
    const noPinnedToTop = eventsLessPosts.filter(p => !p.postSettings[0].pinToTop);
    const eventsPosts = posts.filter(p => p?.eventContentItem?.eventId);
    const eventsIds = eventsPosts.map(p => p.eventContentItem.eventId);
    const eventsPostsNoDuplicates: any[] = [];
    eventsIds.reduce((prev, curr, index) => {
        if (prev.indexOf(curr) === -1) {
            prev.push(curr)
            eventsPostsNoDuplicates.push(eventsPosts[index]);
        };
        return prev;
    }, [])
    const eventsPostsNoDUplicatedEvents = [...noPinnedToTop, ...eventsPostsNoDuplicates].sort((a: any, b: any) => b.created - a.created);
    return [...pinnedToTop, ...eventsPostsNoDUplicatedEvents];
}

export const useDebounce = (callback, delay) => {
    const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

    const debouncedCallback = useCallback((...args: any[]) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);

    return debouncedCallback;
}

export const isMobileApp = () => window.innerWidth < 768